import { FiChevronDown, FiX } from 'react-icons/fi';
import { cn } from '../../../helpers/utils';

interface Props {
  label?: string;
  required?: boolean;
  placeholder?: string;
  onClick: () => void;
  selectedValue: string;
  disabled?: boolean;
  options: { id: string; name: string }[];
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  colorLabel?: string;
  textLabel?: string;
  placeholderClassName?: string;
}

type InputProps =
  | (Props & {
      showClearIcon: true;
      onClearSelectedValue: (e: React.MouseEvent<HTMLButtonElement>) => void;
    })
  | (Props & {
      showClearIcon?: false;
      onClearSelectedValue?: never;
    });

const InputModalMobile = ({
  label,
  required,
  placeholder,
  onClick,
  selectedValue,
  disabled = false,
  options,
  className = '',
  labelClassName = '',
  inputClassName,
  colorLabel,
  textLabel,
  placeholderClassName = '',
  showClearIcon = false,
  onClearSelectedValue,
}: InputProps) => {
  const getNameFromOption = options.find((item) => item.id === selectedValue);

  const displayNameDropDown = () => {
    if (getNameFromOption) {
      return getNameFromOption.name ? (
        getNameFromOption.name
      ) : (
        <span className={cn('text-reliableBlack60', placeholderClassName)}>{placeholder}</span>
      );
    }
    return selectedValue ? (
      selectedValue
    ) : (
      <span className={cn('text-reliableBlack60', placeholderClassName)}>{placeholder}</span>
    );
  };

  return (
    <>
      {label && (
        <label
          className={`block text-sm ${textLabel ? textLabel : 'font-medium'} mt-1 ${colorLabel ? colorLabel : 'text-gray-700'} ${labelClassName}`}
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <div
        className={`${inputClassName} w-full outline-none px-4 py-2 ${disabled ? 'bg-reliableBlack10 text-reliableBlack50' : 'bg-reliableBlack3 text-reliableBlack'} placeholder:text-reliableBlack6 border-b border-reliableBlack30 focus:border-reliableBlack60 lg:px-5 lg:py-4 cursor-pointer flex justify-between ${className}`}
        onClick={() => {
          if (!disabled) onClick();
        }}
      >
        <span>{displayNameDropDown()}</span>
        <span className="text-gray-500">
          {showClearIcon && selectedValue ? (
            <button
              className="text-red-500"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                onClearSelectedValue(e);
              }}
            >
              <FiX />
            </button>
          ) : (
            <FiChevronDown />
          )}
        </span>
      </div>
    </>
  );
};

export default InputModalMobile;
